import Navbar from "../components/shared/Navbar";
import Footer from "../components/shared/Footer";

const Terms = () => {
  return (
    <>
      <Navbar solid />

      <div className="bg-[#F8FAFC] py-10 md:py-14">
        <div className="container mx-auto px-8 md:px-20">
          <div className="bg-white border border-gray-200 rounded-[8px] p-6 md:p-10 shadow-sm">
            <h1 className="text-3xl md:text-4xl font-bold text-[#333333] mb-2">
              CCCSNV Terms and Conditions
            </h1>
            <p className="text-[#1F2937] mb-6">Last Updated: 23-05-2024</p>

            <p className="text-[#1F2937] mb-6 leading-7">
              Welcome to CCCSNV, a service provided by CCC, India. By accessing
              or using our service, you agree to be bound by these Terms and
              Conditions. If you do not agree to these terms, please do not use
              our service.
            </p>

            <h2 className="text-2xl font-semibold text-[#333333] mb-3">
              1. Acceptance of Terms
            </h2>
            <p className="text-[#1F2937] mb-6 leading-7">
              By using CCCSNV, you agree to comply with and be legally bound by
              the terms and conditions outlined in this document. These terms
              apply to all visitors, users, and others who access or use our
              service.
            </p>

            <h2 className="text-2xl font-semibold text-[#333333] mb-3">
              2. Description of Service
            </h2>
            <p className="text-[#1F2937] mb-6 leading-7">
              CCCSNV provides an online platform to create and manage resumes.
              Users can input personal details, education, work experience, and
              other relevant information to generate professional resumes. As
              part of this service, your data may be made available to
              recruiters for potential job opportunities.
            </p>

            <h2 className="text-2xl font-semibold text-[#333333] mb-3">
              3. User Accounts
            </h2>
            <p className="text-[#1F2937] mb-6 leading-7">
              To access certain features of CCCSNV, you must create an account.
              You agree to provide accurate and complete information when
              creating your account. You are responsible for safeguarding your
              password and any activities or actions under your account.
            </p>

            <h2 className="text-2xl font-semibold text-[#333333] mb-3">
              4. Use of Service
            </h2>
            <p className="text-[#1F2937] mb-3 leading-7">
              You agree to use CCCSNV only for lawful purposes and in
              accordance with these terms. You must not use our service:
            </p>
            <ul className="list-disc pl-6 text-[#1F2937] mb-6 leading-7">
              <li>
                In any way that breaches any applicable local, national, or
                international law or regulation.
              </li>
              <li>
                To send, knowingly receive, upload, download, use, or re-use
                any material which does not comply with our content standards.
              </li>
              <li>
                To transmit any unsolicited or unauthorized advertising or
                promotional material.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-[#333333] mb-3">
              5. Intellectual Property
            </h2>
            <p className="text-[#1F2937] mb-6 leading-7">
              All content, trademarks, service marks, logos, and other
              intellectual property displayed on CCCSNV are the property of CCC,
              India or their respective owners. You are not permitted to use
              any of these without the prior written consent of CCC, India or
              the respective owners.
            </p>

            <h2 className="text-2xl font-semibold text-[#333333] mb-3">
              6. Termination
            </h2>
            <p className="text-[#1F2937] mb-6 leading-7">
              We may terminate or suspend your account and access to our service
              immediately, without prior notice or liability, for any reason,
              including if you breach these terms.
            </p>

            <h2 className="text-2xl font-semibold text-[#333333] mb-3">
              7. Limitation of Liability
            </h2>
            <p className="text-[#1F2937] mb-3 leading-7">
              To the maximum extent permitted by law, CCC, India shall not be
              liable for any indirect, incidental, special, consequential, or
              punitive damages, or any loss of profits or revenues, whether
              incurred directly or indirectly, or any loss of data, use,
              goodwill, or other intangible losses resulting from:
            </p>
            <ul className="list-disc pl-6 text-[#1F2937] mb-6 leading-7">
              <li>Your use or inability to use the service.</li>
              <li>
                Any unauthorized access to or use of our servers and/or any
                personal information stored therein.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-[#333333] mb-3">
              8. Governing Law
            </h2>
            <p className="text-[#1F2937] mb-6 leading-7">
              These terms shall be governed and construed in accordance with the
              laws of India, without regard to its conflict of law provisions.
            </p>

            <h2 className="text-2xl font-semibold text-[#333333] mb-3">
              9. Changes to Terms
            </h2>
            <p className="text-[#1F2937] mb-6 leading-7">
              We reserve the right to modify or replace these terms at any
              time. We will provide notice of changes by posting the new terms
              on our website. Your continued use of the service following the
              posting of any changes constitutes acceptance of those changes.
            </p>

            <h2 className="text-2xl font-semibold text-[#333333] mb-3">
              10. Contact Us
            </h2>
            <p className="text-[#1F2937] leading-7">
              If you have any questions about these Terms and Conditions, please
              contact us at:
              <br />
              <br />
              Email: support@cccsnv.com
              <br />
              Address: CCC Digital Private Ltd 101, 1st Floor, Elemental #337,
              Road No. 1, Financial District, Hyderabad, Telangana 500032
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Terms;
